import { Config } from "@onquality/dashboard-ui/lib/config";
import logo from "assets/img/logo.svg";

const settings = {
    logo: logo,
    translationPrefix: 'dashboard',
};

Config.applyConfig('settings', settings);
